module.exports = __webpack_public_path__ + "static/media/grades_icon.394ea898.png";